export default __webpack_public_path__ + "static/media/staff.33eb6e06.png";